const textProps = {
  min: 0,
  max: 10,
  changeValue: 1,
  defaultValue: 1,
  color: "orange",
};
export default textProps;
